import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';
import '../../css/hero.css';
import { WhatWeDo } from './WhatWeDo';
export const Hero = () => (
    <>
        <section
            id='home'
            className="
                flex
                lg:flex-row
                flex-col
                sm:py-16
                py-6
            "
        >
            <div
                className='
                    w-50
                    flex-1
                    flex
                    justify-center
                    lg:items-start
                    items-center
                    flex-col
                    xl:px-0
                    sm:px-16
                    px-6
                    mb-14
                '
            >
                <div className='max-w-[360px]'>
                    <h1 className='text-5xl font-bold tracking-tight'>
                        Organize your job search
                    </h1>
                    <h4 className='pt-[25px] text-2xl tracking-tight mb-[40px]'>
                        Track your job applications and keep your job search organized, all in one place.
                    </h4>
                    <Link
                        to='/connect?active=signup'
                    >
                        <Button 
                            label='Sign up for free'
                        />
                    </Link>
                </div>
            </div>
            <div
                id='large-img-bkgd-0'
                className='
                    w-1/2
                    flex-1
                    relative
                '
            >
                <div id="hero_0" className="ease-all large-img-bkgd" 
                >
            </div>
            </div>
        </section>
        <section
            id='home'
            className="
                flex
                lg:flex-row
                flex-col
                sm:py-16
                py-6
            "
        >
            <div
                className='
                    flex-1
                    flex
                    justify-center
                    lg:items-start
                    items-center
                    flex-col
                    xl:px-0
                    sm:px-16
                    px-6
                    mb-14
                '
            >
                <div className='max-w-[360px]'>
                    <h2 className='text-4xl font-bold tracking-tight'>
                        All your job search details in one place
                    </h2>
                    <h4 className='pt-[25px] text-lg tracking-tight mb-[40px] text-neutral-600'>
                        No more messy job search spreadsheets. Trackr keeps track of every detail about your job opportunities regardless of where you found them. Track contacts, notes, dates, tasks, documents, job descriptions, salaries, locations, company data and more. It's like a CRM for your job search.
                    </h4>
                </div>
            </div>
            <div
                id='large-img-bkgd-1'
                className='
                    w-1/2
                    relative
                '
            >
                <div id="hero_1" className="ease-all large-img-bkgd" 
                >
            </div>
            </div>
        </section>
        <section
            id='home'
            className="
                grid
                lg:grid-cols-3
                sm:grid-cols-2
                grid-cols-1
                gap-y-10
                sm:py-16
                py-6
                columns-3
            "
        >
            <WhatWeDo />
        </section>
    </>
  )

